import { Store, Reducer } from 'redux'
import storage from 'redux-persist/es/storage'
import { persistStore, persistReducer } from 'redux-persist'
import { createFilter } from 'redux-persist-transform-filter'

const authTransform = createFilter(
  'auth', // which reducer
  ['accessToken'],
)

export function persistRootReducer(reducer: Reducer) {
  return persistReducer({
    key: 'ggamerica-webapp',
    storage,
    whitelist: ['auth'],
    transforms: [ authTransform ] // appTransform, authTransform, employeesTransform, accidentsTransform, terminationsTransform ]
  }, reducer)
}


export function getPersistor(store: Store) {
  return persistStore(store)
}



// WEBPACK FOOTER //
// ./src/store/persistor.ts